import { useState, useEffect } from 'react';
import { ThemeMode } from '../types';

export const useTheme = () => {
  const [themeMode, setThemeMode] = useState<ThemeMode>(() => {
    // Загружаем из localStorage при инициализации
    const saved = localStorage.getItem('themeMode') as ThemeMode;
    return saved || 'system';
  });

  // Определяем системную тему
  const getSystemTheme = (): 'light' | 'dark' => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  // Получаем актуальную тему с учетом режима
  const getActualTheme = (): 'light' | 'dark' => {
    if (themeMode === 'system') {
      return getSystemTheme();
    }
    return themeMode;
  };

  // Применяем тему к документу
  const applyTheme = (theme: 'light' | 'dark') => {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  };

  // Меняем режим темы
  const changeThemeMode = (mode: ThemeMode) => {
    setThemeMode(mode);
    localStorage.setItem('themeMode', mode);
    
    const actualTheme = mode === 'system' ? getSystemTheme() : mode;
    applyTheme(actualTheme);
  };

  // Слушаем изменения системной темы
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e: MediaQueryListEvent) => {
      if (themeMode === 'system') {
        applyTheme(e.matches ? 'dark' : 'light');
      }
    };

    // Применяем тему при монтировании
    applyTheme(getActualTheme());

    // Подписываемся на изменения системной темы
    mediaQuery.addEventListener('change', handleChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [themeMode]);

  return {
    themeMode,
    actualTheme: getActualTheme(),
    changeThemeMode,
  };
};

